import { WidgetHeader } from 'legacy/lut/components/widgets/public/partner360/widgetHeader/WidgetHeader'
import { useCallback, useMemo, useState } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { Textarea } from 'core-components/library/inputs'
import { LoaderOverlay } from 'core-components/library/loader'
import { ModalDialog } from 'core-components/library/modalDialog'
import { addPartnersToGlobalPartner } from 'partner360/widgets/gp360Administration/api/addPartnersToGlobalPartner'
import { getJbpGlobalPartnerDetails } from 'partner360/widgets/gp360Administration/components/globalPartnerTable/helpers/getJbpGlobalPartnerDetails'
import { TRANSLATION_KEYS } from 'partner360/widgets/gp360Administration/translations'

import { applyClipboardValues } from './api/applyClipboardValues'
import { ClipboardResultModalContent } from './clipboardResultModalContent/ClipboardResultModalContent'
import { getFilteredPartnerIds } from './helpers/getFilteredPartnerIds'

import styles from './PasteFromClipboardContent.module.scss'

interface IProps {
  onClose: () => void
  globalPartnerId: string
  fYear: number
}

export const PasteFromClipboardContent = ({ onClose, globalPartnerId, fYear }: IProps) => {
  const [value, setValue] = useState('')
  const [isWip, setIsWip] = useState(false)
  const [showClipboardResultModal, setShowClipboardResult] = useState(false)
  const [payloadCount, setPayloadCount] = useState(0)
  const [partnerIdsResponse, setPartnerIdsResponse] = useState<string[]>([])
  const [unmatchedValues, setUnmatchedValues] = useState<string[]>([])

  const crud = getJbpGlobalPartnerDetails(globalPartnerId)

  const isDisabledApplyBtn = useMemo(() => value.length === 0, [value])

  const closeClipboardResultModalContent = useCallback(() => {
    setShowClipboardResult(false)
  }, [])

  const contentProps = useMemo(
    () => ({
      payloadCount,
      responseCount: partnerIdsResponse.length,
      unmatchedValues,
      onClose: () => {
        closeClipboardResultModalContent()
        onClose()
      },
      onAgree: async () => {
        closeClipboardResultModalContent()
        setIsWip(true)
        await addPartnersToGlobalPartner({
          globalPartnerId: globalPartnerId,
          partnerIds: partnerIdsResponse,
          currentFYear: fYear,
        })
        crud.removeQueries(true)
        setIsWip(false)
        onClose()
      },
    }),
    [
      payloadCount,
      partnerIdsResponse,
      onClose,
      unmatchedValues,
      closeClipboardResultModalContent,
      crud,
      fYear,
      globalPartnerId,
    ]
  )

  const onApply = useCallback(async () => {
    setIsWip(true)
    const filteredPartnerIds = getFilteredPartnerIds(value)
    setPayloadCount(filteredPartnerIds.length)
    const { foundPartners, unmatched } = await applyClipboardValues(filteredPartnerIds)

    setPartnerIdsResponse(foundPartners.map((el) => el.PartnerID))
    setUnmatchedValues(unmatched)
    setShowClipboardResult(true)
    setIsWip(false)
  }, [value])

  return (
    <div>
      <LoaderOverlay show={isWip} />
      <WidgetHeader>{TRANSLATION_KEYS.pasteFromClipboard.title}</WidgetHeader>
      <Textarea value={value} onChange={setValue} rows={10} />
      <div className={styles.btnWrapper}>
        <Button disabled={isDisabledApplyBtn} className={styles.btnWrapper__btn} onClick={onApply}>
          <Translation text={TRANSLATION_KEYS.pasteFromClipboard.apply} />
        </Button>
        <Button color={'danger'} onClick={onClose}>
          <Translation text={TRANSLATION_KEYS.pasteFromClipboard.cancel} />
        </Button>
      </div>
      <ModalDialog
        content={ClipboardResultModalContent}
        contentProps={contentProps}
        show={showClipboardResultModal}
        size={'xs'}
        onClose={closeClipboardResultModalContent}
      />
    </div>
  )
}
